export default "__VITE_ASSET__Cx072GCa__"